var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 163,
    viewBox: "0 0 134 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.631 27.5747L45.8202 1.21107C43.6939 0.542212 41.4275 1.72536 40.758 3.8537L1.21231 129.571C0.542821 131.699 1.7238 133.967 3.85011 134.636L87.6611 160.999C89.7874 161.668 92.0539 160.485 92.7234 158.357L132.269 32.6395C132.939 30.5112 131.758 28.2436 129.631 27.5747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.081 64.1283L53.4324 76.9189L61.4018 98.0779L80.0449 85.2901L72.081 64.1283Z",
    fill: "#E33B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1446 11.4873L44.8785 15.785L47.5572 22.8918L53.8221 18.5983L51.1446 11.4873Z",
    fill: "#E33B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5656 139.466L80.3036 143.765L82.9769 150.874L89.243 146.577L86.5656 139.466Z",
    fill: "#E33B73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.9317,
    height: 139.87,
    fill: "white",
    transform: "translate(41.9702) rotate(17.4615)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.eb3ad6b2d27189c569ba6b93e869e7a4.svg";
export { ForwardRef as ReactComponent };